
import { Utils } from "../../../../../services/utils.service";
import { DataCollection } from "../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../infrastructure/enums";
import { TransportData } from "../../../../infrastructure/transportdata";

export class DashboardDropdownHierarchyFetchRequest {
  public static readonly FetchRequestType: string = "DashboardDropdownHierarchyFetchRequest";
  DropdownHierarchyLevel : number = 0;
  ReportFilterType: number = 0;  // Compulsory
  QuarterlyYearType: number = 0;
  HalfYearType: number = 0;
  Month: number = 0;
  FinancialYearRef: number = 0;
  IncentiveRole: number = 0;
  FromDate: string = '';
  ToDate: string = '';

  StateRefs: number[] = [];
  ZoneRefs: number[] = [];
  DistrictRefs: number[] = [];
  BlockRefs: number[] = [];
  PHCRefs: number[] = [];
  AFRefs: number[] = [];
  SCRefs: number[] = [];
  VillageRefs: number[] = [];
  AshaRefs: number[] = [];

  AshaEmployeeRecordRefs: number[] = [];
  AshaPostRefs: number[] = [];

  AFEmployeeRecordRefs: number[] = [];
  AFPostRefs: number[] = [];

  BCMEmployeeRecordRefs: number[] = [];
  BCMPostRefs: number[] = [];

  DCMEmployeeRecordRefs: number[] = [];
  DCMPostRefs: number[] = [];

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, DashboardDropdownHierarchyFetchRequest.FetchRequestType) as DataCollection;
    coll.Entries.push(this);
  }

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  }
}

